import PropTypes from "prop-types";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

const SsoInfoModal = ({ message, onClose }) => (
  <AlertDialog open={message != null} onOpenChange={next => !next && onClose()}>
    <AlertDialogContent size="sm">
      <AlertDialogHeader>
        <AlertDialogTitle>Cannot reset password</AlertDialogTitle>
        <AlertDialogDescription>{message}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogAction onClick={onClose}>Close</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

SsoInfoModal.propTypes = {
  message: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

export default SsoInfoModal;
